module.exports = __webpack_public_path__ + "static/media/Demo-HI-SERVICE.ec3f9634.mp4";